function initializeSlick(context) {
    $(context)
        .find(".desktop-only .thumnbnail-media-position-verticle .thumbnail-list")
        .each(function () {
            var i = $(this);

            var l = i.children("li").not(".thumbnail-list_item--variant"),
                e = l.length;

            if (e < 2) {
                return;
            }

            if (i.hasClass("slick-initialized")) return;

            var t = l.first().outerHeight(!0) + 5,
                s = Math.min(5, e),
                n = s * t;

            if ($(window).width() >= 768) {
                i.slick({
                    slidesToShow: s,
                    slidesToScroll: 1,
                    infinite: !1,
                    adaptiveHeight: !1,
                    vertical: !0,
                    verticalSwiping: !0,
                    variableWidth: !1,
                    cssEase: "ease-in-out",
                    speed: 300,
                    nextArrow:
                        '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m8 10.207l3.854-3.853l-.707-.708L8 8.793L4.854 5.646l-.708.708z" clip-rule="evenodd"/></svg></button>',
                    prevArrow:
                        '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m8 5.293l3.854 3.853l-.707.708L8 6.707L4.854 9.854l-.708-.708z" clip-rule="evenodd"/></svg></button>',
                });

                i.on("afterChange", function () {
                    var l = i.find('.slick-slide[aria-hidden="false"]').length * t;
                    i.find(".slick-list").css("max-height", l + "px");
                });

                setTimeout(function () {
                    i.find(".slick-list").css("max-height", n + "px");
                }, 300);

                
                i.find("li").on("click", function () {
                    var index = $(this).index();
                    i.slick("slickGoTo", index);
                });
            }
        });
}

$(document).ready(function () {
    initializeSlick(document); 
});


var resizeTimer;
$(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
        if ($(window).width() >= 768) {
            initializeSlick(document);
        }
    }, 250);
});
